<template>
  <div>
    <div>
      <!-- 活动概览 -->
      <div v-show="curIndex == 1">
        <jd-form
          key="activityOverview"
          :formInfo="activityOverviewInfo"
          immediately
          emitReset
          isreData
          :formData.sync="activityOverviewParams"
          @reset="activityOverviewReset"
          @search="activityOverviewSearch"
        >
        </jd-form>
        <div style="margin-top: 20px" class="flex-spc-x">
          <jd-button type="blue" @click="fildsVisible = true"
            >字段配置</jd-button
          >
        </div>
        <jd-table
          style="margin-top: 20px"
          key="activityOverviewTalbe"
          ref="activityOverviewTableRef"
          :tableInfo="activityOverviewTableInfo"
          :tableData="activityOverviewList"
          :loading="activityOverviewLoading"
          @sort-change="activityOverviewSortChange"
        >
        </jd-table>
      </div>
      <!-- 入会转化概览 -->
      <div v-show="curIndex == 2">
        <jd-form
          key="memberConversion"
          :formInfo="memberConversionInfo"
          :formData.sync="memberConversionParams"
          immediately
          emitReset
          isreData
          @reset="memberConversionReset"
          @search="memberConversionSearch"
        >
          <template #orderAmount="{ form }">
            <div class="flexc-cen-x">
              <el-select
                v-model="form.orderAmountType"
                placeholder="请选择"
                style="width: 150px"
              >
                <el-option label="累计付款金额" value="0"> </el-option>
                <el-option label="累计完成金额" value="1"> </el-option>
              </el-select>
              <el-select
                v-model="form.orderAmountCompareType"
                placeholder="请选择"
                style="width: 120px; margin: 0 10px"
              >
                <el-option label="大于等于" value="0"> </el-option>
                <el-option label="小于等于" value="1"> </el-option>
              </el-select>
              <el-input
                v-model="form.orderAmountCompareValue"
                placeholder="请输入"
                style="width: 120px"
                @input="
                  form.orderAmountCompareValue = getNumberData(
                    1,
                    $event,
                    1,
                    0,
                    99999
                  )
                "
              ></el-input>
            </div>
          </template>
        </jd-form>

        <jd-table
          style="margin-top: 20px"
          key="memberConversionTable"
          ref="memberConversionTableRef"
          :tableInfo="memberConversionTableInfo"
          :tableData="memberConversionList"
          :loading="memberConversionLoading"
          @sort-change="memberConversionSortChange"
        >
          <template #activityTime="{ row }">
            {{ `${row.startTime} - ${row.endTime}` }}
          </template>
        </jd-table>
      </div>
      <!-- 奖品数据 -->
      <div v-show="curIndex == 3">
        <jd-table
          style="margin-top: 20px"
          key="prizeDataTable"
          ref="prizeDataTableRef"
          row-key="id"
          :tree-props="{ children: 'channalOverviews' }"
          :tableInfo="prizeDataTableInfo"
          :tableData="prizeDataList"
          :loading="prizeDataLoading"
          @sort-change="prizeDataSortChange"
        >
          <template #prizeName="{ row }">
            <span>{{ row.prizeName || "" }}</span>
          </template>
          <template #prizeType="{ row }">
            <span>{{ row.prizeType | prizeType }}</span>
          </template>
          <template #sellerLinkeName="{ row }">
            {{ row.sellerLinkeName || "/" }}
          </template>
          <template #activityTime="{ row }">
            {{ `${row.startTime} - ${row.endTime}` }}
          </template>
        </jd-table>
      </div>
    </div>
    <el-dialog title="字段设置" :visible.sync="fildsVisible" width="1000px">
      <div>
        <el-descriptions
          title=""
          :column="1"
          :border="true"
          :labelStyle="{ width: '80px' }"
        >
          <el-descriptions-item
            v-for="(item, index) in fileConfigData"
            :key="index"
            :label="item.name"
          >
            <el-checkbox
              v-model="prop.checked"
              v-for="(prop, propIndex) in item.propertyList"
              :key="propIndex"
              :label="prop.prop"
              :disabled="prop.disabled"
            >
              {{ prop.label }}
            </el-checkbox>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <jd-button @click="fildsVisible = false">取消</jd-button>
        <jd-button type="blue" @click="saveFieldList">保存</jd-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  yunqiStatsActivityOverview,
  getFieldList,
  saveFieldList,
  openCardConversionOverview,
  prizeSendOverview,
  activityReviewExport,
} from "@/api/marketing/acitivityReview.js";
import { getShopInfo } from "@/api/sellerController.js";
import fileConfigData from "@/views/interactiveMarketing/acitivityReview/data.js";
export default {
  name: "acitivity_review",
  props: {
    curIndex: {
      type: [String, Number],
      default: "1",
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    targetUser: {
      type: [String, Number],
      default: "",
    },
    queryType: {
      type: [String, Number],
      default: "1",
    },
    defaultOrderStartTime: {
      type: String,
      default: "",
    },
    defaultOrderEndTime: {
      type: String,
      default: "",
    },
    activityOverviewData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    openCardConversionOverviewData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  created() {
    const data = JSON.parse(JSON.stringify(fileConfigData));
    this.fileConfigData = data.map((v) => {
      if (v.name == "活动信息") {
        v.propertyList = [
          {
            prop: "sellerLinkeName",
            label: "渠道名称",
            checked: true,
            disabled: true,
            sortable: false,
          },
        ];
      }
      return v;
    });
    this.getShopInfo();
    this.getFieldList();
    this.getPrizeDataList();
    this.activityOverviewInfo[1].startTime = this.defaultOrderStartTime;
    this.activityOverviewInfo[1].endTime = this.defaultOrderEndTime;
  },
  components: {},
  data() {
    return {
      control: false,
      fieldList: [],
      bindshop: [],
      fildsVisible: false,
      fileConfigData: [],
      // 活动概览
      activityOverviewInfo: [
        {
          label: "统计时间：",
          prop: "daytime",
          type: "btnCustomDate",
          value: 3,
          noShowTime: false,
          disabled: true,
          defaultStartDate: this.rowData.startTime,
          options: [
            { label: "近7天", value: 1, day: 7 },
            { label: "近15天", value: 2, day: 15 },
            { label: "近30天", value: 3, day: 30 },
            {
              label: "自定义",
              value: 4,
              custom: true,
              dateType: "datetime",
              startTime: "",
              endTime: "",
              startKey: "startTime",
              endKey: "endTime",
              pickerOptionsStart: (startTime, endTime) => {
                return {
                  disabledDate: (time) => {
                    return (
                      time.getTime() <
                        new Date(this.rowData.startTime).getTime() -
                          24 * 60 * 60 * 1000 ||
                      time.getTime() > new Date(endTime).getTime()
                    );
                  },
                };
              },
              pickerOptionsEnd: (startTime, endTime) => {
                return {
                  disabledDate: (time) => {
                    return (
                      time.getTime() <
                      new Date(startTime).getTime() + 24 * 60 * 60 * 1000
                    );
                  },
                };
              },
            },
          ],
        },
        {
          label: "下单时间：",
          type: "DateRange",
          startKey: "orderStartTime",
          endKey: "orderEndTime",
          dateType: "datetime",
          disabled: true,
          defalutLimit: true,
        },
      ],
      activityOverviewLoading: false,
      activityOverviewList: [],
      activityOverviewParams: {
        sortField: "",
        asc: "",
        startTime: "",
        endTime: "",
        orderStartTime: "",
        orderEndTime: "",
        queryType: "1",
        targetUser: "",
        activityId: this.rowData.id,
        activityType: this.rowData.activityType,
      },
      // 入会转化概览
      memberConversionLoading: false,
      memberConversionTableInfo: [
        {
          label: "投放渠道",
          prop: "sellerLinkeName",
          width: "120px",
        },
        {
          label: "新增入会人数",
          prop: "newMemberCount",
          width: "140px",
          sortable: "custom",
        },
        {
          label: "入会率",
          prop: "memberRate",
          width: "120px",
          sortable: "custom",
        },
        {
          label: "新增会员付款人数",
          prop: "newMemberPayUserCount",
          width: "180px",
          sortable: "custom",
        },
        {
          label: "新增会员付款订单数",
          prop: "newMemberPayOrderCount",
          width: "180px",
          sortable: "custom",
        },
        {
          label: "新增会员付款金额",
          prop: "newMemberPayAmount",
          width: "180px",
          sortable: "custom",
        },
        {
          label: "新增会员客单价（付款）",
          prop: "newMemberPayCustomerPrice",
          width: "200px",
          sortable: "custom",
        },
        {
          label: "新增会员完成订单人数",
          prop: "newMemberCompleteUserCount",
          width: "200px",
          sortable: "custom",
        },
        {
          label: "新增会员完成金额",
          prop: "newMemberCompleteAmount",
          width: "180px",
          sortable: "custom",
        },
        {
          label: "新增会员客单价（完成）",
          prop: "newMemberCompleteCustomerPrice",
          width: "200px",
          sortable: "custom",
        },
      ],
      memberConversionInfo: [
        {
          label: "统计活动入会后：",
          type: "Input",
          prop: "joinDays",
          append: "天内的订单",
          value: "30",
        },
        {
          label: "订单金额：",
          prop: "orderAmountCompareValue",
          value: "",
          slot: "orderAmount",
          placeholder: "请输入",
        },
        {
          label: "订单金额：",
          prop: "orderAmountCompareType",
          value: "0",
          isHide: true,
        },
        {
          label: "订单金额：",
          prop: "orderAmountType",
          value: "1",
          isHide: true,
        },
        {
          label: "入会时间：",
          type: "DateRange",
          startKey: "startTime",
          endKey: "endTime",
          dateType: "datetime",
          defalutLimit: true,
          startTime: this.rowData.startTime,
          endTime: this.rowData.endTime,
        },
      ],
      memberConversionList: [],
      memberConversionParams: {
        joinDays: "",
        startTime: "",
        endTime: "",
        orderAmountType: "1",
        orderAmountCompareType: "0",
        orderAmountCompareValue: "",
        sortField: "",
        asc: "",
        queryType: "1",
        targetUser: "",
        activityId: this.rowData.id,
        activityType: this.rowData.activityType,
      },
      // 奖品数据
      prizeDataTableInfo: [
        {
          label: "奖品名称",
          prop: "prizeName",
          slot: "prizeName",
        },
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeType",
        },
        {
          label: "投放渠道",
          prop: "sellerLinkeName",
          slot: "sellerLinkeName",
        },
        {
          label: "已发放数量",
          prop: "sendNum",
          sortable: "custom",
        },
        {
          label: "已发放价值",
          prop: "sendValue",
        },
      ],
      prizeDataList: [],
      prizeDataLoading: false,
      prizeDataParams: {
        targetUser: "",
        activityId: "",
        queryType: 1,
        sortField: "",
        asc: "",
        activityId: this.rowData.id,
        activityType: this.rowData.activityType,
      },
    };
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "礼品卡";
      } else if (num == "12") {
        result = "专享价";
      } else if (num == "13") {
        result = "令牌";
      }
      return result;
    },
  },
  watch: {
    targetUser: function (newVal, oldVal) {
      this.initData();
    },
    queryType: function (newVal, oldVal) {
      this.initData();
    },
    curIndex: function (newVal, oldVal) {
      this.initData();
    },
  },
  computed: {
    activityOverviewTableInfo() {
      let tableInfo = [];
      this.fileConfigData.forEach((item) => {
        item.propertyList.forEach((prop) => {
          if (this.fieldList == null) {
            // 没有配置字段时，默认显示所有字段
            if (prop.sortable != false) {
              prop.sortable = "custom";
            }
            tableInfo.push(prop);
          } else if (
            this.fieldList.includes(prop.prop) ||
            prop.label == "渠道名称"
          ) {
            // 配置了字段时，只显示配置的字段
            if (prop.sortable != false) {
              prop.sortable = "custom";
            }
            tableInfo.push(prop);
          }
        });
      });
      return tableInfo;
    },
    loginUserInfo() {
      const loginUserInfo = this.$store.state.loginUserInfo || {};
      return loginUserInfo;
    },
  },
  methods: {
    initData() {
      if (this.queryType == "1") {
        if (this.curIndex == 1) {
          this.getActivityOverviewList();
        } else if (this.curIndex == 2) {
          this.getMemberConversionList();
        } else if (this.curIndex == 3) {
          this.getPrizeDataList();
        }
      }
    },
    exportData(remark) {
      let data = {
        remark,
      };
      if (this.curIndex == "1") {
        data.activityStatsOverviewQueryDTO = this.activityOverviewParams;
      } else if (this.curIndex == "2") {
        data.openCardConversionOverviewQueryVO = this.memberConversionParams;
      } else {
        data.prizeOverviewQueryDTO = this.prizeDataParams;
      }
      activityReviewExport(data).then((res) => {
        if (res.code == 1) {
          this.$message({
            message: "导出成功",
            type: "success",
          });
        } else {
          this.$message.warning(res.message || "导出失败");
        }
      });
    },
    getShopInfo() {
      getShopInfo().then((res) => {
        if (res.code == 1) {
          const arr = res.data.bindshop || [];
          this.bindshop = arr;
        }
      });
    },

    // 奖品数据
    prizeDataSortChange({ column, prop, order }) {
      console.log(column, prop, order);
      if (order == "descending") {
        // 降序
        this.prizeDataParams.asc = false;
      } else {
        // 升序
        this.prizeDataParams.asc = true;
      }
      if (order == null) {
        this.prizeDataParams.sortField = "";
        this.prizeDataParams.asc = "";
      } else {
        this.prizeDataParams.sortField = prop;
      }
      this.getPrizeDataList();
    },
    prizeDataReset() {
      this.prizeDataParams.sortField = "";
      this.prizeDataParams.asc = "";
      this.getPrizeDataList();
      this.$refs.prizeDataTableRef.handleClearSort();
    },
    prizeDataSearch(form) {
      console.log(form);
      this.getPrizeDataList();
    },
    handlePrizeSort() {
      const sortField = this.prizeDataParams.sortField;
      const asc = this.prizeDataParams.asc;
      if (sortField) {
        this.prizeDataList = this.prizeDataList.map((v) => {
          if (v.channalOverviews) {
            v.channalOverviews.sort((a, b) => {
              console.log(a, b);
              if (asc) {
                return a[sortField] - b[sortField];
              } else {
                return b[sortField] - a[sortField];
              }
            });
          }
          return v;
        });
      }
    },
    getPrizeDataList() {
      this.prizeDataLoading = true;
      this.prizeDataParams.targetUser = this.targetUser;
      prizeSendOverview(this.prizeDataParams)
        .then((res) => {
          this.prizeDataLoading = false;
          if (res && res.code == 1) {
            let data = res.data || [];
            data.forEach((item) => {
              item.id = item.prizeId;
              if (item.channalOverviews && item.channalOverviews.length > 0) {
                item.channalOverviews.forEach((channel, index) => {
                  channel.id = channel.prizeId + "" + index;
                  channel.prizeName = item.prizeName;
                  channel.prizeType = item.prizeType;
                });
              }
            });
            let arr = res.data || [];
            arr.forEach((item) => {
              Object.keys(item).forEach((key) => {
                if (key.includes("Rate")) {
                  item[key] += "%";
                }
              });
            });
            this.prizeDataList = arr || [];
            if (this.prizeDataParams.sortField) {
              this.handlePrizeSort();
            }
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.prizeDataLoading = false;
        });
    },

    // 入会转化概览
    memberConversionSortChange({ column, prop, order }) {
      if (order == "descending") {
        // 降序
        this.memberConversionParams.asc = false;
      } else {
        // 升序
        this.memberConversionParams.asc = true;
      }
      if (order == null) {
        this.memberConversionParams.sortField = "";
        this.memberConversionParams.asc = "";
      } else {
        this.memberConversionParams.sortField = prop;
      }
      this.getMemberConversionList();
    },
    getMemberConversionList() {
      this.memberConversionLoading = true;
      this.memberConversionParams.targetUser = this.targetUser;
      openCardConversionOverview(this.memberConversionParams)
        .then((res) => {
          this.memberConversionLoading = false;
          if (res && res.code == 1) {
            if (res.data.length > 0) {
              res.data.unshift({
                ...this.openCardConversionOverviewData,
                sellerLinkeName: "汇总",
              });
            }
            console.log(res.data);

            this.memberConversionList = res.data || null;
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.memberConversionLoading = false;
        });
    },
    memberConversionReset() {
      this.memberConversionParams.sortField = "";
      this.memberConversionParams.asc = "";
      this.getMemberConversionList();
      this.$refs.memberConversionTableRef.handleClearSort();
    },
    memberConversionSearch(form) {
      console.log(form);
      this.getMemberConversionList();
    },
    saveFieldList() {
      let data = {
        venderId: this.loginUserInfo.venderId,
        type: 3,
      };
      let fieldList = [];
      this.fileConfigData.forEach((item) => {
        item.propertyList.forEach((prop) => {
          if (prop.checked) {
            fieldList.push(prop.prop);
          }
        });
      });
      data.fieldJson = JSON.stringify(fieldList || []);
      saveFieldList(data).then((res) => {
        if (res.code == 1) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.getFieldList();
          this.fildsVisible = false;
        }
      });
    },
    getFieldList() {
      let data = {
        venderId: this.loginUserInfo.venderId,
        type: 3,
      };
      getFieldList(data)
        .then((res) => {
          if (res && res.code == 1) {
            const fieldJson = res.data && res.data.fieldJson;
            this.fieldList = (fieldJson && JSON.parse(fieldJson)) || null;
            if (this.fieldList) {
              this.fileConfigData.forEach((item) => {
                item.propertyList.forEach((prop) => {
                  if (
                    this.fieldList.includes(prop.prop) ||
                    prop.label == "渠道名称"
                  ) {
                    prop.checked = true;
                  } else {
                    prop.checked = false;
                  }
                });
              });
            }
          } else {
            this.fieldList = null;
          }
        })
        .catch((err) => {
          console.log(err);
          this.fieldList = null;
        });
    },

    // 活动概览
    activityOverviewSortChange({ column, prop, order }) {
      console.log(column, prop, order);
      if (order == "descending") {
        // 降序
        this.activityOverviewParams.asc = false;
      } else {
        // 升序
        this.activityOverviewParams.asc = true;
      }
      if (order == null) {
        this.activityOverviewParams.sortField = "";
        this.activityOverviewParams.asc = "";
      } else {
        this.activityOverviewParams.sortField = prop;
      }
      this.getActivityOverviewList();
    },
    activityOverviewReset() {
      this.activityOverviewParams.sortField = "";
      this.activityOverviewParams.asc = "";
      this.getActivityOverviewList();
      this.$refs.activityOverviewTableRef.handleClearSort();
    },
    activityOverviewSearch(form) {
      console.log(form);
      this.getActivityOverviewList();
    },
     getActivityOverviewList() {
      this.activityOverviewParams.targetUser = this.targetUser;
      let data = { ...this.activityOverviewParams };
      delete data.daytime;
      this.activityOverviewLoading = true;
      Promise.all([yunqiStatsActivityOverview(data), yunqiStatsActivityOverview({...data,queryType: 0})
        ]).then((list)=>{
          this.activityOverviewLoading = false;
          if (list.length>0 && list[0].code == 1) {
            let arr = list[0].data || [];
            if(list[1].data.length>0) {
                arr.unshift({
                ...list[1].data[0],
                sellerLinkeName: "汇总",
              })
            } else {
              arr.unshift({
                sellerLinkeName: "汇总",
              })
            }
              arr.forEach((item) => {
              Object.keys(item).forEach((key) => {
                if (key.includes("Rate")) {
                  item[key] += "%";
                }
              });
            });
            this.activityOverviewList = arr;
            this.activityOverviewParams.total = list[0].data.total || 0;
          } else {
            if(list.length>0) {
              this.$message.warning(list[0].message);
            }
          }
        })

      
    },
  },
};
</script>

<style lang="scss" scoped></style>
